<div class="row">
  <div class="col-12">
    <div class="mb-4 text-center">
      <p class="mb-0" *ngIf="formMode === PromptFormMode.CREATE">{{ 'Prompts.Create.Description' | localize }}</p>
      <p class="mb-0" *ngIf="formMode === PromptFormMode.EDIT">{{ 'Prompts.Edit.Description' | localize }}</p>
      <p class="mb-0" *ngIf="formMode === PromptFormMode.VIEW">{{ 'Prompts.View.Description' | localize }}</p>
    </div>

        <div class="p-4">
          <form [formGroup]="promptForm">

            <!-- Prompt Adı -->
            <div class="row mb-4">
              <div class="col-12">
                <mat-card class="cardWithShadow mb-4">
                  <mat-card-header class="mb-3">
                    <mat-card-title class="fs-5 fw-medium">{{ 'Prompts.Form.PromptName' | localize }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput formControlName="promptName" placeholder="{{ 'Prompts.Form.PromptNamePlaceholder' | localize }}">
                  <mat-error *ngIf="promptForm.get('promptName')?.hasError('required') && !isViewOnly">
                    {{ 'Prompts.Form.PromptNameRequired' | localize }}
                  </mat-error>
                  <mat-error *ngIf="promptForm.get('promptName')?.hasError('whitespace') && !isViewOnly">
                    {{ 'Prompts.Form.PromptNameCannotBeEmpty' | localize }}
                  </mat-error>
                </mat-form-field>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>

            <!-- Açıklama -->
            <div class="row mb-4">
              <div class="col-12">
                <mat-card class="cardWithShadow mb-4">
                  <mat-card-header class="mb-3">
                    <mat-card-title class="fs-5 fw-medium">{{ 'Prompts.Form.Description' | localize }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea matInput formControlName="description" rows="3" placeholder="{{ 'Prompts.Form.DescriptionPlaceholder' | localize }}"></textarea>
                </mat-form-field>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>

            <!-- Prompt Metni -->
            <div class="row mb-4">
              <div class="col-12">
                <mat-card class="cardWithShadow mb-4">
                  <mat-card-header class="mb-3">
                    <mat-card-title class="fs-5 fw-medium">{{ 'Prompts.Form.PromptText' | localize }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea matInput formControlName="promptText" rows="8" placeholder="{{ 'Prompts.Form.PromptTextPlaceholder' | localize }}"></textarea>
                  <mat-error *ngIf="promptForm.get('promptText')?.hasError('required') && !isViewOnly">
                    {{ 'Prompts.Form.PromptTextRequired' | localize }}
                  </mat-error>
                  <mat-error *ngIf="promptForm.get('promptText')?.hasError('minlength') && !isViewOnly">
                    {{ 'Prompts.Form.PromptTextMinLength' | localize }}
                  </mat-error>
                  <mat-error *ngIf="promptForm.get('promptText')?.hasError('whitespace') && !isViewOnly">
                    {{ 'Prompts.Form.PromptTextCannotBeEmpty' | localize }}
                  </mat-error>
                </mat-form-field>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>

            <!-- Etiketler Tab -->
            <div class="row mb-4">
              <div class="col-12">
                <mat-card class="cardWithShadow mb-4">
                  <mat-card-content>
                    <mat-tab-group>
                      <mat-tab [label]="'Prompts.Form.Tags' | localize">
                        <div class="pt-4">
                          <!-- Düzenleme/ekleme modunda chip giriş alanı -->
                          <ng-container *ngIf="!isViewOnly">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-chip-grid #chipGrid [attr.aria-label]="'Prompts.Form.TagsAriaLabel' | localize">
                                <mat-chip-row *ngFor="let tag of tags"
                                            [removable]="true"
                                            (removed)="removeTag(tag)"
                                            color="primary">
                                  {{tag}}
                                  <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                  </button>
                                </mat-chip-row>
                                <input placeholder="{{ 'Prompts.Form.TagsPlaceholder' | localize }}"
                                      [matChipInputFor]="chipGrid"
                                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                      (matChipInputTokenEnd)="addTag($event)"
                                      #tagInput />
                                      <mat-hint class="">{{ 'Prompts.Form.TagsHint' | localize }}</mat-hint>
                              </mat-chip-grid>
                            </mat-form-field>
                          </ng-container>

                          <!-- Görüntüleme modunda etiket listesi -->
                          <div *ngIf="isViewOnly">
                            <div *ngIf="tags && tags.length > 0" class="d-flex flex-wrap gap-2">
                                    <span *ngFor="let tag of tags" class="badge bg-primary text-white px-2 py-1 rounded">{{tag}}</span>
                            </div>
                                  <div *ngIf="!tags || tags.length === 0" class="">
                              {{ 'Prompts.Form.NoTags' | localize }}
                            </div>
                          </div>
                        </div>
                      </mat-tab>
                    </mat-tab-group>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>

            <!-- Kategori Tab -->
            <div class="row mb-4">
              <div class="col-12">
                <mat-card class="cardWithShadow mb-4">
                  <mat-card-header class="mb-3">
                    <mat-card-title class="fs-5 fw-medium">{{ 'Prompts.Form.Category' | localize }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <mat-tab-group [selectedIndex]="0" class="overflow-hidden">
                      <mat-tab [label]="'Prompts.Form.Category' | localize">
                        <div class="pt-4 overflow-hidden">
                          <div *ngIf="!isViewOnly" class="pt-2">
                            <mat-radio-group formControlName="type" (change)="onTypeChange($event.value)">
                              <div class="row g-3 mx-0">
                                <div class="col-12 col-sm-6 col-lg-4 mb-3" *ngFor="let type of promptTypes">
                                  <mat-radio-button [value]="type.value" class="d-block text-nowrap">
                              {{ type.display | localize }}
                                  </mat-radio-button>
                                </div>
                              </div>
                            </mat-radio-group>
                      </div>
                          <div *ngIf="isViewOnly" class="view-only-field pt-2">
                            <p class="mb-0">{{ getTypeDisplay(selectedType) }}</p>
                      </div>
                          <div *ngIf="promptForm.get('type')?.invalid && promptForm.get('type')?.dirty && !isViewOnly" class="text-danger mt-3">
                          {{ 'Prompts.Form.TypeRequired' | localize }}
                      </div>
                        </div>
                      </mat-tab>
                    </mat-tab-group>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>

            <!-- Dosya Yükleme -->
            <div class="row mb-4" *ngIf="!isViewOnly">
              <div class="col-12">
                <mat-card class="cardWithShadow mb-4">
                  <mat-card-header class="mb-3">
                    <mat-card-title class="fs-5 fw-medium">{{ 'Prompts.Form.FileUpload' | localize }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>

                  <div class="row g-3">
                    <!-- Sol taraf - Seçilen Dosyalar -->
                    <div class="col-12 col-lg-4">
                      <div class="h-100">
                        <h6 class="mb-3">{{ 'Prompts.Form.SelectedFiles' | localize }}</h6>

                        <!-- Seçilen dosyalar listesi -->
                        <div *ngIf="selectedFiles.length > 0 || selectedDataSourceIds.length > 0" class="overflow-auto h-25rem">

                          <!-- Yüklenen dosyalar -->
                          <div *ngFor="let file of selectedFiles; let i = index"
                               class="d-flex align-items-center justify-content-between p-3 border rounded mb-3">
                            <div class="d-flex align-items-center flex-grow-1 me-2">
                              <mat-icon class="me-3 text-danger flex-shrink-0">picture_as_pdf</mat-icon>
                              <div class="flex-grow-1 overflow-hidden">
                                <span class="fw-medium d-block text-truncate">{{ file.name }}</span>
                                <small class=" d-block small">{{ (file.size / 1024).toFixed(1) }} KB</small>
                              </div>
                            </div>
                            <button mat-icon-button
                                    color="warn"
                                    size="small"
                                    class="flex-shrink-0"
                                    (click)="removeUploadedFile(i)"
                                    matTooltip="Kaldır">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>

                          <!-- Mevcut dosyalardan seçilenler -->
                          <div *ngFor="let fileId of selectedDataSourceIds"
                               class="d-flex align-items-center justify-content-between p-3 border rounded mb-3">
                            <div class="d-flex align-items-center flex-grow-1 me-2">
                              <mat-icon class="me-3 text-primary flex-shrink-0">description</mat-icon>
                              <div class="flex-grow-1 overflow-hidden">
                                <span class="fw-medium d-block text-truncate">Kayıtlı Dosya ID: {{ fileId }}</span>
                                <small class=" d-block small">{{ 'Prompts.Form.RegisteredInSystem' | localize }}</small>
                              </div>
                            </div>
                            <button mat-icon-button
                                    color="warn"
                                    size="small"
                                    class="flex-shrink-0"
                                    (click)="removeSelectedDataSource(fileId)"
                                    matTooltip="Kaldır">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        </div>

                        <!-- Dosya seçilmediğinde -->
                        <div *ngIf="selectedFiles.length === 0 && selectedDataSourceIds.length === 0"
                             class="d-flex align-items-center justify-content-center text-center border rounded h-25rem">
                          <div class="p-3">
                            <mat-icon class="mb-3 fs-3">folder_open</mat-icon>
                            <p class="mb-0 small">{{ 'Prompts.Form.NoFileSelected' | localize }}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sağ taraf - Dosya Yükleme Sekmeleri -->
                    <div class="col-12 col-lg-8">
                      <mat-tab-group [(selectedIndex)]="selectedTabIndex">
                        <!-- Dosya Yükleme Sekmesi -->
                        <mat-tab [label]="'Prompts.Form.UploadNewFile' | localize" [disabled]="selectedDataSourceIds.length > 0">
                          <div class="pt-4">
                            <!-- Disable durumu mesajı -->
                            <div *ngIf="selectedDataSourceIds.length > 0" class="alert alert-warning py-3 mb-4 rounded">
                              <mat-icon class="me-2 align-middle">info</mat-icon>
                              <span class="align-middle">{{ 'Prompts.Form.FileUploadDisabledDueToSelection' | localize }}</span>
                            </div>

                            <!-- Drag & Drop Alanı -->
                            <div class="border border-2 border-dashed rounded p-4 p-md-5 text-center d-flex flex-column align-items-center justify-content-center position-relative h-20rem"
                                  [class.border-primary]="isDragOver && selectedDataSourceIds.length === 0"
                                  [class.opacity-50]="selectedDataSourceIds.length > 0"
                                  [style.cursor]="selectedDataSourceIds.length > 0 ? 'not-allowed' : 'pointer'"
                                  (dragover)="selectedDataSourceIds.length === 0 ? onDragOver($event) : null"
                                  (dragleave)="selectedDataSourceIds.length === 0 ? onDragLeave($event) : null"
                                  (drop)="selectedDataSourceIds.length === 0 ? onDrop($event) : null"
                                  (click)="selectedDataSourceIds.length === 0 ? triggerFileInput() : null">
                              <mat-icon class="mb-3 mb-md-4 text-primary display-7">cloud_upload</mat-icon>
                               <h5 class="mb-2 mb-md-3 fs-6 fs-md-5">{{ 'Prompts.Form.UploadFiles' | localize }}</h5>
                               <p class="mb-2 mb-md-3 small">{{ 'Prompts.Form.SelectOrDragFiles' | localize }}</p>
                               <p class="mb-0 small ">{{ 'Prompts.Form.SupportedFileTypes' | localize }}</p>

                              <input #fileInput type="file" class="d-none" multiple
                                     accept=".pdf,.txt,.md"
                                     (change)="onFileSelect($event)"
                                     [disabled]="selectedDataSourceIds.length > 0">
                            </div>

                            <!-- Yükleme durumu -->
                            <div *ngIf="selectedFiles.length > 0" class="mt-4 text-center">
                              <div class="alert alert-success py-3 rounded">
                                <mat-icon class="me-2 align-middle">check_circle</mat-icon>
                                <span class="fw-medium align-middle">{{ selectedFiles.length }} {{ 'Prompts.Form.FilesUploadedSuccessfully' | localize }}</span>
                              </div>
                            </div>
                          </div>
                        </mat-tab>

                        <!-- Mevcut Dosyalar Sekmesi -->
                        <mat-tab [label]="'Prompts.Form.RegisteredFiles' | localize" [disabled]="selectedFiles.length > 0">
                          <div class="pt-4">
                            <!-- Disable durumu mesajı -->
                            <div *ngIf="selectedFiles.length > 0" class="alert alert-warning py-3 mb-4 rounded">
                              <mat-icon class="me-2 align-middle">info</mat-icon>
                              <span class="align-middle">{{ 'Prompts.Form.FileSelectionDisabledDueToUpload' | localize }}</span>
                            </div>

                            <div class="overflow-auto h-25rem">
                              <app-resource-management
                                #resourceManagement
                                [selectedOrganisationId]="selectedOrganisationId || (window.globalActiveUser?.organisationAccount?.id || 1)"
                                [enableSelection]="selectedFiles.length === 0"
                                (selectedFilesChange)="onDataSourcesSelected($event)">
                              </app-resource-management>
                            </div>
                          </div>
                        </mat-tab>
                      </mat-tab-group>
                    </div>
                  </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>



                        <!-- Test Ayarları -->
            <div *ngIf="!isViewOnly" class="row mb-4">
              <div class="col-12">
                <mat-card class="cardWithShadow mb-4">
                  <mat-card-header class="mb-3">
                    <mat-card-title class="fs-5 fw-medium">{{ 'Prompts.Form.TestSettings' | localize }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>

                  <!-- Model Seçimi -->
                  <div class="row mb-4 g-3">
                    <div class="col-12 col-md-6">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'Prompts.Form.AIModel' | localize }}</mat-label>
                        <mat-select formControlName="testModel">
                          <mat-option *ngFor="let model of availableModels" [value]="model.value">
                      {{ model.display }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Ton Seçimi -->
                    <div class="col-12 col-md-6">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'Prompts.Form.Tone' | localize }}</mat-label>
                        <mat-select formControlName="tone">
                          <mat-option *ngFor="let tone of availableTones" [value]="tone.value">
                            {{ tone.display | localize }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Temperature Slider -->
                  <div class="row mb-4">
                    <div class="col-12 col-md-8 col-lg-6">
                      <div class="temperature-container">
                        <label class="form-label d-block mb-3 fw-medium">{{ 'Prompts.Form.CreativityLevel' | localize }}:</label>
                        <div class="d-flex align-items-center gap-3">
                          <span class="small text-nowrap">{{ 'Prompts.Form.Consistent' | localize }} (0)</span>
                          <mat-slider min="0" max="1" step="0.1" class="flex-grow-1">
                            <input matSliderThumb formControlName="temperature">
                          </mat-slider>
                          <span class="fw-semibold text-center">{{ promptForm.get('temperature')?.value }}</span>
                          <span class="small text-nowrap">{{ 'Prompts.Form.Creative' | localize }} (1)</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Test Sorusu -->
                  <div class="row mb-2">
                    <div class="col-12">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'Prompts.Form.TestQuestion' | localize }}</mat-label>
                        <textarea matInput formControlName="userQuestion" rows="2" placeholder="{{ 'Prompts.Form.TestQuestionPlaceholder' | localize }}"></textarea>
                      </mat-form-field>
                </div>
                </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </form>

          <!-- Test Sonuçları Bölümü -->
        <mat-card class="cardWithShadow mb-4" *ngIf="(testMode || testLoading) && !isViewOnly">
          <div class="mt-4 p-4 border rounded">
                          <div class="d-flex justify-content-between align-items-center mb-4">
                <h3 class="m-0 fs-4 fw-semibold">{{ 'Prompts.TestSection.Results' | localize }}</h3>
              <button mat-icon-button color="warn" (click)="clearTestResults()" [disabled]="testLoading">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <!-- Loading durumu -->
            <div *ngIf="testLoading" class="text-center py-5">
              <mat-spinner diameter="40" class="mx-auto mb-3"></mat-spinner>
              <p class=" mb-2">{{ 'Prompts.TestSection.Loading' | localize }}</p>
              <small class=" small opacity-75">{{ 'Prompts.TestSection.PleaseWait' | localize }}</small>
            </div>

            <!-- Test sonuçları -->
            <div *ngIf="!testLoading && testResultDto" class="py-3">
              <div class="d-flex align-items-center mb-3">
                <mat-icon class="text-success me-2 fs-5">check_circle</mat-icon>
                <span class="ms-2 fw-bold">{{ 'Prompts.TestSection.Completed' | localize }}</span>
                <span class="ms-3 badge bg-primary text-white">{{ getSelectedModelName() }}</span>
                <span class="ms-2 badge bg-secondary text-white">{{ getSelectedToneName() }}</span>
              </div>
              <div *ngIf="this.testResultDto?.metrics" class="mb-3">
                <span class="fw-medium small">
                  {{ 'Prompts.TestSection.UsedTokens' | localize }}: {{ this.testResultDto.metrics.inputTokens }}
                  <ng-container *ngIf="this.testResultDto.metrics.responseStartLatency">
                    | {{ 'Prompts.TestSection.StartTime' | localize }}: {{ this.testResultDto.metrics.responseStartLatency | number:'1.2-2' }} {{ 'Prompts.TestSection.Seconds' | localize }}
                  </ng-container>
                  <ng-container *ngIf="this.testResultDto.metrics.responseCompleteLatency">
                    | {{ 'Prompts.TestSection.EndTime' | localize }}: {{ this.testResultDto.metrics.responseCompleteLatency | number:'1.2-2' }} {{ 'Prompts.TestSection.Seconds' | localize }}
                  </ng-container>
                </span>
              </div>
              <div class="p-3 border rounded lh-base">
                <p class="mb-0">{{ this.testResultDto.response }}</p>
              </div>
            </div>
          </div>
        </mat-card>
      <mat-card-actions align="end" class="p-4 mt-4 pt-4">
        <div class="d-flex gap-3 align-items-center">
          <button mat-button (click)="onCancel()">
            {{ isViewOnly ? ('Prompts.Actions.Close' | localize) : ('Prompts.Actions.Cancel' | localize) }}
          </button>
          <ng-container *ngIf="!isViewOnly">
            <button mat-raised-button color="accent" class="me-4" (click)="onTest()"
                    [disabled]="!promptForm.valid || testLoading">
              <span *ngIf="!testLoading">{{ 'Prompts.Actions.Test' | localize }}</span>
              <span *ngIf="testLoading">{{ 'Prompts.TestSection.Loading' | localize }}</span>
              <mat-icon *ngIf="!testLoading" class="ms-2">science</mat-icon>
              <mat-spinner *ngIf="testLoading" diameter="20" color="accent" class="ms-2"></mat-spinner>
            </button>
            <button mat-raised-button color="primary" (click)="onSave()"
                    [disabled]="!promptForm.valid || saving || (formMode === PromptFormMode.EDIT && !hasChanges)">
              <span *ngIf="!saving">{{ formMode === PromptFormMode.EDIT ? ('Prompts.Actions.Update' | localize) : ('Prompts.Actions.Save' | localize) }}</span>
              <span *ngIf="saving">{{ formMode === PromptFormMode.EDIT ? ('Prompts.Actions.Updating' | localize) : ('Prompts.Actions.Saving' | localize) }}</span>
              <mat-icon *ngIf="!saving" class="ms-2">save</mat-icon>
              <mat-spinner *ngIf="saving" diameter="20" color="accent" class="ms-2"></mat-spinner>
            </button>
          </ng-container>
        </div>
      </mat-card-actions>
  </div>
</div>
